import {
  CommentDetailContainer,
  CommentDetailContainerData,
  CommentSpan,
  DefaultUserCircle,
} from "./incidentSummary.styled";

export interface CommentComponentProps {
  initialsColor: string;
  firstName: string;
  lastName: string;
  userEmail: string;
  postedOn: string;
  commentText: string;
  image?: string;
}

export interface CommentDetailProps {
  commentId: number;
  firstName: string;
  lastName: string;
  userEmail: string;
  postedOn: string;
  commentText: string;
  image?: string;
}

export const CommentDetail = ({ initialsColor, firstName, lastName, userEmail, postedOn, commentText, image }: CommentComponentProps) => {
  const initials = firstName[0] + lastName[0]
  return (
    <CommentDetailContainer>
      <span>
        {image ? <> </> : <DefaultUserCircle backgroundColor={initialsColor}>{initials}</DefaultUserCircle>}
      </span>

      <CommentDetailContainerData>
        <span>
          <span className='pr-3'>{userEmail}</span>
          <span>{postedOn}</span>
        </span>
        <CommentSpan style={{whiteSpace: 'pre-line'}}>{commentText}</CommentSpan>
      </CommentDetailContainerData>
    </CommentDetailContainer>
  );
};

export default CommentDetail;
